import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Phone, Users, Lightbulb, User } from "lucide-react";

const navItems = [
  { path: "/calls", label: "Calls", icon: Phone },
  { path: "/clients", label: "Clients", icon: Users },
  { path: "/insights", label: "Insights", icon: Lightbulb },
  { path: "/profile", label: "Profile", icon: User },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-xl mx-auto py-5 px-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl flex items-center justify-center shadow-sm">
              <Phone className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-semibold text-slate-900">Sales Call Coach</span>
          </div>
        </div>
      </header>

      <main className="flex-1 pb-28 pt-8">
        <div className="max-w-lg mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-md border border-slate-200 p-8">
            <Outlet />
          </div>
        </div>
      </main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-10 shadow-lg">
        <div className="max-w-xl mx-auto">
          <div className="flex items-center justify-around py-3">
            {navItems.map((item) => {
              const isActive = location.pathname.startsWith(item.path);
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={`flex flex-col items-center gap-1.5 px-6 py-3 rounded-xl transition-all ${
                    isActive 
                      ? "text-teal-600 bg-teal-50" 
                      : "text-slate-400 hover:text-slate-600"
                  }`}
                >
                  <item.icon className={`w-6 h-6 ${isActive ? 'scale-110' : ''} transition-transform`} />
                  <span className="text-xs font-medium">{item.label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
}
